import { HStack, Text, Box, Button } from "@chakra-ui/react";
import { Eye, PencilLine } from "phosphor-react";
import React, { useState } from "react";
import TableStyle from "../../Components/Common/TableStyle";
import { COLORS } from "../../Helper/Colors";
import { ModalComponent, Pagination, Search } from "../../Components/Common/UI";
import TableV6 from "../../Components/Common/TableV6";
import Api from "../../Helper/ApiHandler";
import { useQuery } from "react-query";
import { useDebounce } from "../../Helper/Hooks/useDebounce";
import ViewStaticPage from "./ViewStaticPage";
import EditStaticPage from "./EditStaticPage";

const StaticPageTable = () => {
  const startingValue = {
    name: "",
  };
  const api = new Api();
  const [search, setSearch] = useState("");
  const [params, setParams] = useState({
    pageNo: 1,
    pageSize: 25,
    order: "DESC",
    sortBy: "created_at",
  });

  const [data, setData] = useState([]);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [modalType, setModalType] = useState("ADD");
  const [initialValues, setInitialValues] = useState({});

  const debouncedSearchTerm = useDebounce(search, 1500);

  const fetchStaticPageData = async ({ queryKey }) => {
    const StaticPageData = await api.post(`${"/auth/static-content/list"}`, {
      page: queryKey[2].pageNo,
      search: queryKey[1],
      order: queryKey[2].order,
      sort_by: queryKey[2].sortBy,
    });
    setData(StaticPageData?.data?.rows);
    return StaticPageData;
  };

  const {
    isLoading,
    data: StaticPageData,
    refetch,
  } = useQuery(
    ["StaticPageData", debouncedSearchTerm, params],
    fetchStaticPageData
  );

  const handleviewmodel = (row) => {
    setIsViewModalOpen(true);
    setInitialValues(row.original);
  };

  const handleViewModalClose = async () => {
    setIsViewModalOpen(false);
    await refetch();
  };

  const handleeditmodel = (row) => {
    setIsEditModalOpen(true);
    setInitialValues(row.original);
  };

  const handleEditModalClose = async () => {
    setIsEditModalOpen(false);
    await refetch();
  };

  const handlePageChange = (page) => {
    setParams((prev) => ({ ...prev, pageNo: page.selected + 1 }));
  };

  const handleSortBy = (sortBy) => {
    setParams((prev) => ({
      ...prev,
      sortBy: sortBy[0]?.id || "id",
      order: sortBy[0]?.desc ? "DESC" : "ASC",
    }));
  };

  const columns = [
    {
      Header: () => (
        <Box>
          <Text marginLeft={"5px"}>Title</Text>
        </Box>
      ),
      accessor: "title",
      Cell: (row) => <Text textAlign={"center"}>{row.value}</Text>,
      sortable: false,
    },
    {
      Header: () => (
        <Box>
          <Text marginLeft={"5px"}>Action</Text>
        </Box>
      ),

      Cell: (row) => (
        <Box display={"flex"} justifyContent={"center"}>
          <Button
            backgroundColor={COLORS.brand}
            color={"white"}
            marginRight={"5px"}
            title="View"
            onClick={() => {
              handleviewmodel(row);
            }}
            fontSize={"14px"}
          >
            {<Eye size={18} color={"white"} />}
          </Button>

          <Button
            title="Edit"
            backgroundColor={COLORS.brand}
            height={"40px"}
            color={"white"}
            fontSize={"14px"}
            onClick={() => {
              handleeditmodel(row);
            }}
          >
            {<PencilLine size={18} color={"white"} />}
          </Button>
        </Box>
      ),
      sortable: false,
    },
  ];

  return (
    <>
      <HStack
        display={"flex"}
        justifyContent={"space-between"}
        paddingBottom={"10px"}
      >
        <Search
          search={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setParams({ ...params, pageNo: 1 });
          }}
          resetSearch={() => setSearch("")}
        />
      </HStack>
      <TableStyle version={6}>
        <TableV6
          columns={columns}
          data={StaticPageData?.data?.rows}
          handleSortBy={handleSortBy}
          isLoading={isLoading}
          key={"master-rep-table"}
        />
        {data.length ? (
          <Pagination
            key={"racePagination"}
            handlePageChange={handlePageChange}
            pageSize={10}
            total={StaticPageData?.data?.count || 0}
            currentPage={params.pageNo}
          />
        ) : null}
      </TableStyle>
      <ModalComponent
        isOpen={isViewModalOpen}
        onClose={handleViewModalClose}
        size="5xl"
      >
        <ViewStaticPage
          initialValues={initialValues}
          onClose={handleViewModalClose}
          startingValue={startingValue}
        />
      </ModalComponent>
      <ModalComponent
        isOpen={isEditModalOpen}
        onClose={handleEditModalClose}
        trapFocus={false}
        size="5xl"
      >
        <EditStaticPage
          initialValues={initialValues}
          onClose={handleEditModalClose}
          startingValue={startingValue}
        />
      </ModalComponent>
    </>
  );
};

export default StaticPageTable;
